import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiMapPin } from "react-icons/fi";
import { useParkSettings, parkStatus } from "../../utils/parkSettings";
import "./ParkStatusCard.css";

// The park's own card on Home (info only): name, city and today's opening hours
// from /park in the admin console, as a status line and a bar through the open hours.
export default function ParkStatusCard() {
  const { t } = useTranslation("home");
  const settings = useParkSettings();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  const status = parkStatus(settings, now);
  const isOpen = status.state === "open";
  const text = {
    open: t("statusOpen", { close: status.close }),
    before: t("statusBefore", { open: status.open }),
    after: t("statusAfter"),
    closedDay: status.reason ? t("closedTodayReason", { reason: status.reason }) : t("closedToday"),
  }[status.state];

  return (
    <div className="park-card">
      <div className="park-card-head">
        <div className="profile-menu-icon profile-menu-icon--yellow"><FiMapPin size={17} /></div>
        <div className="profile-menu-text">
          <h4>{t("parkName")}</h4>
          <p>{t("parkCity")}</p>
        </div>
      </div>
      <div className="park-card-status">
        <div className="park-card-state">
          <span className={`park-card-dot park-card-dot--${isOpen ? "open" : "closed"}`} />
          {text}
        </div>
        <div
          className="park-card-bar"
          role="progressbar"
          aria-label={t("statusLabel")}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(status.progress * 100)}
        >
          <div className={`park-card-bar-fill${isOpen ? " park-card-bar-fill--open" : ""}`} style={{ width: `${status.progress * 100}%` }} />
        </div>
        {status.state !== "closedDay" && (
          <div className="park-card-times">
            <span>{status.open}</span>
            <span>{status.close}</span>
          </div>
        )}
      </div>
    </div>
  );
}
